"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeData = void 0;
const request_1 = require("./request");
const getNodeData = (path, pageSize, activeFilters, languageParam) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (path.substring(path.length - 1, path.length) !== '/') {
            // always have trailing slash when making api calls.
            path += '/';
        }
        const result = yield (0, request_1.request)(`${path}GetContent/`, request_1.RequestType.POST, Object.assign(Object.assign({ pageSize }, activeFilters), { language: languageParam }));
        return result.data;
    }
    catch (error) {
        throw new Error(error);
    }
});
exports.getNodeData = getNodeData;
